import React, {Component} from 'react';
import { connect } from '~/redux/connect';
import PropTypes from 'prop-types';
import views from '../../Views/views';
import {
    getConfirmNavigationMessages,
    getCurrentModelId, getCurrentViewOrNull, getDialogModelId
} from "~/stateGetter";
import ModelTreeDataManager from "~/ui/ModelDataManager/ModelTreeDataManager";
import ItemViewDialog from "~/ui/ItemViewDialog/ItemViewDialog";
import getLoadingState from "~/conclude/loading";
import ErrorPage from "~/ui/Pages/ErrorPage/ErrorPage";
import {pushClose} from "~/actions/navigation_actions";
// import HelpDataManager from "~/ui/ModelDataManager/HelpDataManager";
import transform from "lodash/transform"
import isEqual from "lodash/isEqual"
import isObject from "lodash/isObject"
import { MaybeScrollableView } from "./MaybeScrollableView";
import { PageTitleSync } from '~/ui/PageTitleSync';

class ModelPage extends Component {
    static propTypes = {
        view: PropTypes.string,
    };

    getView = () => {
        let view = (this.props.view in views) ? this.props.view : 'empty';
        let View = views[view];

        const handlers = {
            'close': () => {
                // avoid esc keyboard conflict with cancelNavigation
                if(this.props.messages.length > 0)  { return; }
                this.props.pushClose();
            }
        };

        const keyMap = {
            'close': 'esc',
        };


        return (
            <MaybeScrollableView view={this.props.view}>
                <ModelTreeDataManager />
                {/* <HelpDataManager /> */}
                <PageTitleSync />


                <ItemViewDialog modelId={this.props.dialogModelId} />
                <View modelId={this.props.modelId} />
            </MaybeScrollableView>
        );
    };

    render() {
        if(this.props.error) {
            return <ErrorPage error={this.props.error} />
        }

        return this.getView();
    }
}

function difference(object, base) {
    function changes(object, base) {
        return transform(object, function(result, value, key) {
            if (!isEqual(value, base[key])) {
                result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value;
            }
        });
    }
    return changes(object, base);
}

const areStatePropsEqual = (prev, curr) => {
    return isEqual(prev, curr);
};

const RXModelPage = connect(
    (state) =>  {
        let error = getLoadingState(state, {
            error: ['modelDataLoadingError'],
        }).error;

        if(error) {
            return { error }
        }

        const theModelIdCandidate = getCurrentModelId(state);

        return {
            error: false,
            modelId: theModelIdCandidate,
            dialogModelId: getDialogModelId(state),
            view: getCurrentViewOrNull(state),
            messages: getConfirmNavigationMessages(state)
        };
    },
    (dispatch) => ({
        pushClose: () => dispatch(pushClose())
    }),
    null,
    { areStatePropsEqual }
)(ModelPage);

export default RXModelPage;